import * as Sentry from '@sentry/browser';
import type { GraphQLFormattedError } from 'graphql';

import { ERROR_MESSAGES } from 'common/constants/errorMessages';
import { EGraphQLError } from 'common/types';

export function getErrorMessage(error: GraphQLFormattedError) {
    const errorCode = error?.extensions?.code as
        | keyof typeof ERROR_MESSAGES
        | undefined;

    // Don't return an error message for AuthNotLoggedIn and TrialExpired
    if (
        [EGraphQLError.AuthNotLoggedIn, EGraphQLError.TrialExpired].includes(
            errorCode as EGraphQLError
        )
    )
        return;

    if (import.meta.env.MODE === 'production') Sentry.captureException(error);

    if (!errorCode || (errorCode && !ERROR_MESSAGES[errorCode])) {
        return ERROR_MESSAGES['General'];
    }

    return ERROR_MESSAGES[errorCode];
}
